import React, { Component } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import Link from 'gatsby-link';
import ReactPixel from 'react-facebook-pixel';
import queryString from 'query-string';

import testsMockup from '../assets/images/tests-mockup.png';
import laptop from '../assets/images/laptop.png';
import SignupButton from '../components/buttons/SignupButton';

const { GATSBY_FB_PIXEL_ID } = process.env;

class IndexPage extends Component {
  componentDidMount() {
    const { search } = this.props.location;

    if (GATSBY_FB_PIXEL_ID) {
      ReactPixel.init(process.env.GATSBY_FB_PIXEL_ID);
      const { fb_ad } = queryString.parse(search);
      if (fb_ad) {
        ReactPixel.pageView();
      }
    }
  }

  render() {
    return (
      <div className="IndexPage">
        <div className="IndexPage__billboard">
          <div className="circles">
            <div className="circle" />
            <div className="circle" />
            <div className="circle" />
          </div>

          <div className="container">
            <h1 className="title">Reduce Time Spent Managing Your <span>Radon Testing Business</span></h1>
            <h2 className="subTitle">Generate client, state and quality assurance reports in minutes, not hours.</h2>

            <SignupButton className="btn btn-success btn-lg" />

            <Link
              to="/demo-request"
              className="btn btn-outline-light btn-lg"
            >
              Book a Demo
            </Link>
          </div>
        </div>

        <div className="section IndexPage__benefits">
          <div className="container">
            <div className="row">
              <div className="col-md-6 save-time left-side">
                <h3 className="title">Save time, stay compliant</h3>
                <p className="desc">
                  Perform mobile on-site data entry that will instantly create professional state,
                  quality assurance and consumer reports. Receive notifications for duplicate and
                  cross-check testing. Also be alerted about any devices that need calibration.
                </p>
              </div>
              <div className="col-md-6">
                <div className="tests-mockup">
                  <img
                    src={testsMockup}
                    alt="radon testing interface"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="section gray IndexPage__benefits">
          <div className="container">
            <div className="row">
              <div className="col-md-6 order-1 order-md-0">
                <div className="laptop">
                  <img
                    src={laptop}
                    alt="dashboard"
                  />
                </div>
              </div>

              <div className="col-md-6 left-side">
                <h3 className="title">Your mission control</h3>
                <p className="desc">
                  Managing your radon testing efforts shouldn&apos;t be difficult.
                  With RadonEasy&apos;s software, you get one unified platform to run
                  your business with ease.
                </p>

                <ul className="check-list">
                  <li>Generate reports in seconds<FontAwesomeIcon icon={['fal', 'check']} /></li>
                  <li>Review tests in the field<FontAwesomeIcon icon={['fal', 'check']} /></li>
                  <li>Manage users and roles<FontAwesomeIcon icon={['fal', 'check']} /></li>
                  <li>Track expiring devices<FontAwesomeIcon icon={['fal', 'check']} /></li>
                  <li>Customize consumer reports<FontAwesomeIcon icon={['fal', 'check']} /></li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="section green">
          <div className="container footer-cta">
            <h2 className="title">Reduce your radon testing efforts today</h2>
            <SignupButton className="btn btn-light btn-lg" />
          </div>
        </div>
      </div>
    );
  }
}

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js